import * as betgalaxy from './RaceRunnerForm.styles.betgalaxy';
import * as betprofessor from './RaceRunnerForm.styles.betprofessor';
import * as fiestabet from './RaceRunnerForm.styles.fiestabet';
import * as goldenrush from './RaceRunnerForm.styles.goldenrush';
import * as juicybet from './RaceRunnerForm.styles.juicybet';
import * as puntcity from './RaceRunnerForm.styles.puntcity';
import * as questbet from './RaceRunnerForm.styles.questbet';
import * as sterlingparker from './RaceRunnerForm.styles.sterlingparker';
import * as vikingbet from './RaceRunnerForm.styles.vikingbet';
import * as volcanobet from './RaceRunnerForm.styles.volcanobet';
import * as wellbet from './RaceRunnerForm.styles.wellbet';
import * as betroyale from './RaceRunnerForm.styles.betroyale';
import * as forsport from './RaceRunnerForm.styles.forsport';
import * as junglebet from './RaceRunnerForm.styles.junglebet';
import * as sugarcastle from './RaceRunnerForm.styles.sugarcastle';
import * as buffalobet from './RaceRunnerForm.styles.buffalobet';
import * as titanbet from './RaceRunnerForm.styles.titanbet';
import * as slambet from './RaceRunnerForm.styles.slambet';
import * as gigabet from './RaceRunnerForm.styles.gigabet';
import * as betstride from './RaceRunnerForm.styles.betstride';
import * as templebet from './RaceRunnerForm.styles.templebet';
import * as goldenbet888 from './RaceRunnerForm.styles.goldenbet888';
import * as hyperbet from './RaceRunnerForm.styles.hyperbet';
import * as bet777 from './RaceRunnerForm.styles.bet777';
import * as chromabet from './RaceRunnerForm.styles.chromabet';
import * as bet575 from './RaceRunnerForm.styles.bet575';
import * as epicodds from './RaceRunnerForm.styles.epicodds';
import * as pyramidbet from './RaceRunnerForm.styles.pyramidbet';
import * as magnumbet from './RaceRunnerForm.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  betroyale,
  forsport,
  junglebet,
  sugarcastle,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
